import * as Yup from "yup";
import { yupRichText } from "./yupRules";

export const newEmailSchema = (t) =>
  Yup.object().shape({
    recipients: Yup.array().min(1, t("NewMessageModal.Recipients.Required")),
    subject: Yup.string().required(t("NewMessageModal.Subject.ErrorRequired")),
    message: yupRichText(t("NewMessageModal.Message.ErrorRequired")),
  });

export const newSmsSchema = (t, availableSms, maxChars) => {
  if (availableSms) {
    return Yup.object().shape({
      recipients: Yup.array()
        .min(1, t("NewMessageModal.Recipients.Required"))
        .max(
          availableSms,
          t("NewMessageModal.Recipients.ErrorBalance", {
            balance: availableSms,
          })
        ),
      subject: Yup.string().nullable(),
      message: yupRichText(
        t("NewMessageModal.Message.ErrorRequired")
      ).richLength(maxChars, t("NewMessageModal.Message.ErrorLength")),
    });
  }
  return Yup.object().shape({
    recipients: Yup.array().min(0, t("NewMessageModal.Recipients.Required")),
    subject: Yup.string().nullable(),
    message: yupRichText(t("NewMessageModal.Message.ErrorRequired")).richLength(
      maxChars,
      t("NewMessageModal.Message.ErrorLength")
    ),
  });
};
